/** One CSV cell: always quoted; spreadsheet formulas neutralised, but plain numbers such as a refund's -15.00 left as numbers. */
export function csvCell(v: string | number | null | undefined): string {
  const s = v == null ? '' : String(v);
  return `"${(/^[=+\-@]/.test(s) && !/^-\d+(\.\d+)?$/.test(s) ? `'${s}` : s).replace(/"/g, '""')}"`;
}

/**
 * A download's file name from what is on screen: "egka", what the list is, each
 * filter that is set, then today's date, e.g.
 * egka-payments-refunds-and-chargebacks-cash-from-2026-10-01-2026-10-25.csv.
 * With no filters the list is called "all".
 */
export function csvName(list: string, filters: (string | null | undefined | false)[] = [], on: Date = new Date()): string {
  const slug = (s: string) => s.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/£/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const set = filters.filter((f): f is string => !!f && !!slug(f)).map(slug);
  const day = `${on.getFullYear()}-${String(on.getMonth() + 1).padStart(2, '0')}-${String(on.getDate()).padStart(2, '0')}`;
  return ['egka', slug(list), ...(set.length ? set : ['all']), day].join('-').slice(0, 180) + '.csv';
}
